import { render, staticRenderFns } from "./PartidosModal.vue?vue&type=template&id=205355df"
import script from "./PartidosModal.vue?vue&type=script&lang=js"
export * from "./PartidosModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports